import React, { Component } from 'react';
import { Button, Col, Label, Input, Form, FormGroup } from 'reactstrap';
import Dialog from 'apa/containers/Dialog';
import { connect } from 'react-redux';
import * as categories from 'catalog/actions/categories'
import autobind from 'autobind-decorator';


@connect(
    state => ({
        activeCategory: state.categories.activeCategory
    }),
    dispatch => ({
        add: (category) => dispatch(categories.addCategory(category))
    })
)
export default class NewCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            name: '',
            parent: ''
        };
    }

    @autobind
    toggleNewCategoryDialog() {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    @autobind
    setNewCategoryName(e) {
        const name = e.target.value;
        this.setState({
            ...this.state.category, name: name
        });
    }

    @autobind
    confirmNewCategory() {
        const {activeCategory} = this.props
        const {name} = this.state
        let newCategory;
        if(activeCategory) {
            newCategory = {
                parent: activeCategory.id,
                name: name
            }
        }
        else {
            newCategory = {
                name: name
            }

        }
        this.props.add(newCategory);
        this.toggleNewCategoryDialog()
    }

    render() {
        const { activeCategory } = this.props;
        return (
            <Col sm={3}>
                <Button color='primary' onClick={this.toggleNewCategoryDialog}>
                    Neue Kategorie anlegen
                </Button>
                <Dialog
                    isOpen={this.state.isOpen}
                    toggle={this.toggleNewCategoryDialog}
                    confirm={this.confirmNewCategory}
                    title="Neue Kategorie anlegen"
                >
                    <Form>
                        {
                            activeCategory &&
                            <FormGroup>
                                <Label for="parent">Oberkatergorie</Label>
                                <Input
                                    type="text"
                                    value={activeCategory.name}
                                    readOnly
                                    required
                                />
                            </FormGroup>
                        }
                        <FormGroup>
                            <Label for="category_name">Bezeichnung</Label>
                            <Input
                                type="text"
                                id="category_name"
                                value={this.state.name}
                                onChange={this.setNewCategoryName}
                                required
                            />
                        </FormGroup>
                    </Form>
                </Dialog>
            </Col>
        )
    }
}


